import script from "./ModalDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=c78ff090&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c78ff090"]])

export default __exports__